export default __webpack_public_path__ + "static/news_default-426c96f2ff6cfa3b7d4b13e2b669ca9b.jpg";